import { FC } from "react";
import { MotivationType } from "tm-shared/types";

import AverageIcon from "@/assets/icons/average.svg?react";
import BottleIcon from "@/assets/icons/bottle.svg?react";
import DropIcon from "@/assets/icons/drop.svg?react";
import MarketIcon from "@/assets/icons/market.svg?react";
import UahIcon from "@/assets/icons/uah.svg?react";

export const KPI_ICONS: Partial<Record<MotivationType, FC>> = {
    a: AverageIcon,
    b: BottleIcon,
    l: DropIcon,
    m: UahIcon,
    p: MarketIcon,
} as const;
